{
  "de": {
    "directUpload": {
      "title": "Hochladen",
      "chooseFiles": "Dateien auswählen",
      "dropzone": {
        "textMultiple": "Dateien hier ablegen zum Hochladen",
        "textDirectory": "Ordner hier ablegen",
        "text": "Datei hier ablegen zum Hochladen",
        "or": "oder",
        "browse": "durchsuchen",
        "browseDirectory": "Ordner auswählen"
      },
      "previewImage": {
        "remove": "Entfernen"
      },
      "actions": {
        "upload": "Hochladen",
        "close": "Schließen"
      }
    }
  }
}
